export default __webpack_public_path__ + "static/media/Ability_Leadership.ca598f54.png";